<template>
  <div id="app">
    <HeaderShop/>
    <router-view/>
    <Foot/>
    <Loading :class="{ show: this.isLoading }"/>
    <notifications/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Loading from "./components/Loading";
import Header from "./components/Header";
import Foot from "./components/Foot";
import HeaderShop from "./components/Header-Shop";
import {mapActions} from "vuex";

export default {
  name: 'App',
  components: {HeaderShop, Foot, Header, Loading},
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions(['checkLogin'])
  },
  created() {
    this.checkLogin();
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue